export default {
	namespaced: true,
	state: {
		is: false,
		isKioskDomain: false, // 當前域名是否為 Kiosk 域名
	},
	mutations: {
		SET_IS(state, value) {
			state.is = value
		},
		SET_IS_KIOSK_DOMAIN(state, value) {
			state.isKioskDomain = value
		},
	},
}
